import { useState, useEffect } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { useUpdateCasoFolder } from '@/hooks/useCasoFolders';
import { CasoFolder } from '@/types/casos';
import { FolderIconSelector } from './FolderIconSelector';
import { FolderColorSelector } from './FolderColorSelector';

interface EditFolderDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  folder: CasoFolder | null;
}

export function EditFolderDialog({ open, onOpenChange, folder }: EditFolderDialogProps) {
  const [name, setName] = useState('');
  const [icon, setIcon] = useState('folder');
  const [color, setColor] = useState('blue');
  const { mutate: updateFolder, isPending } = useUpdateCasoFolder();

  useEffect(() => {
    if (folder) {
      setName(folder.name);
      setIcon(folder.icon || 'folder');
      setColor(folder.color || 'blue');
    }
  }, [folder]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!name.trim() || !folder) return;

    updateFolder(
      { id: folder.id, name: name.trim(), icon, color },
      {
        onSuccess: () => {
          onOpenChange(false);
        },
      }
    );
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Editar Pasta</DialogTitle>
        </DialogHeader>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <Label htmlFor="folder-name-edit">Nome da Pasta</Label>
            <Input
              id="folder-name-edit"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Ex: Cliente ABC Ltda"
              autoFocus
            />
          </div>

          <FolderIconSelector value={icon} onChange={setIcon} />
          
          <FolderColorSelector value={color} onChange={setColor} />

          <div className="flex justify-end gap-2">
            <Button type="button" variant="outline" onClick={() => onOpenChange(false)}>
              Cancelar
            </Button>
            <Button type="submit" disabled={!name.trim() || isPending}>
              {isPending ? 'Salvando...' : 'Salvar'}
            </Button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
}
